<template>
    <div>
        <edit-content
            v-if="wysiwyg"
            ref="input"
            v-model="inputValue"
            form
            :disabled="disabled"
            :required="required"
            :rules="rulesValue"
            :error-messages="errorMessagesValue"
            :label="labelValue"
            :hide-toolbar="hideToolbar"
            :inline="inline"
            :readonly="readonly"
        />
        <edit-paragraph
            v-else
            ref="input"
            v-model="inputValue"
            form
            :readonly="readonly"
            :disabled="disabled"
            :required="required"
            :rules="rulesValue"
            :error-messages="errorMessagesValue"
            :label="labelValue"
        />
    </div>
</template>

<script>
import BaseField from './BaseField';
export default {
    name: 'Description',
    extends: BaseField,
    props: {
        wysiwyg: {
            type: Boolean,
            default: false
        },
        hideToolbar: {
            type: Boolean,
            default: false
        },
        inline: {
            type: Boolean,
            default: false
        }
    }
};
</script>
